import { signInWithEmailAndPassword, updateEmail } from "firebase/auth"

import { auth } from "./auth"

export const changeEmail = async (
  currentPassword: string,
  newEmail: string,
) => {
  const user = auth.currentUser
  if (!user) {
    throw new Error("ログインしてください")
  }
  if (!user.email) {
    throw new Error("ログイン中のアカウントのメールアドレスが無効です")
  }
  await signInWithEmailAndPassword(auth, user.email, currentPassword)
  return await updateEmail(user, newEmail)
}

export const getCurrentEmail = () => {
  const user = auth.currentUser
  if (!user) {
    throw new Error("ログインしてください")
  }
  if (!user.email) {
    throw new Error("ログイン中のアカウントのメールアドレスが無効です")
  }
  return user.email
}
